<template>
    <div class="row justify-content-center">
        <div>
            <b-button
                variant="info"
                class="  btn  btn-info waves-effect waves-light "
                data-animation="fadein"
                data-overlaycolor="#38414a"
                @click="onClick(customRef)"
            >
                Show files
            </b-button>
        </div>

        <div class="row justify-content-center ">
            <b-modal
                :id="customRef"
                :hide-footer="true"
                title="Uploaded Files"
                class="block p-6"
            >
                <b-card>
                    <p
                        v-for="item in items.map(file => file.filename)"
                        :key="item"
                    >
                        {{ item }}
                    </p>
                </b-card>
                <div class="pt-3">
                    <b-button
                        class="mb-2 justify-content-center"
                        variant="danger"
                        @click="showDeleteModal(items)"
                    >
                        Delete all files
                    </b-button>
                    <delete-modal
                        :id="customRef"
                        :is-open="isDeleteModalOpen"
                        title="Are you sure about deleting these climate files?"
                        @agree="onAgree"
                        @disagree="onCloseDeleteModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import DeleteModal from '@/components/elements/DeleteModal';

export default {
    components: {
        DeleteModal
    },

    props: {
        items: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            selectedFiles: [],
            isDeleteModalOpen: false
        };
    },

    computed: {
        customRef() {
            return (
                Math.random()
                    .toString(36)
                    .substring(2, 30)
                    .match(/[a-zA-Z]+/g)
                    .join('') + 'Filesmodal'
            );
        }
    },

    methods: {
        onClick(customRef) {
            this.$emit('onClick');
            this.$bvModal.show(customRef);
        },

        onAgree() {
            this.$emit('onAgree', this.filesToDelete);
            this.isDeleteModalOpen = false;
        },

        showDeleteModal(items) {
            this.filesToDelete = items;
            this.isDeleteModalOpen = true;
        },

        onCloseDeleteModal() {
            this.idToDelete = null;
            this.isDeleteModalOpen = false;
        }
    }
};
</script>

<style lang="scss"></style>
